<template>
  <a
      class="request-branch-btn"
      href="https://forms.treasurehost24.com"
      target="_blank"
      rel="noopener noreferrer"
      v-b-tooltip.hover
      :title="msg('Open the new-branch request form in a new tab')"
  >
    <feather-icon icon="PlusCircleIcon" size="16" class="request-branch-btn__icon"/>
    <span class="request-branch-btn__label">{{ msg('Request new branch') }}</span>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RequestBranchButton',
  computed: {
    ...mapGetters('translator', ['msg']),
  },
}
</script>

<style lang="scss" scoped>
.request-branch-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  margin-right: 10px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  color: #1a1205;
  background: linear-gradient(135deg, #EDCFA0 0%, #D4A96A 55%, #B8894C 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(184, 137, 76, 0.32);
  transition: transform 0.14s ease, box-shadow 0.18s ease, filter 0.18s ease;
  text-decoration: none;
}

.request-branch-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(184, 137, 76, 0.42);
  filter: brightness(1.03);
  color: #1a1205;
  text-decoration: none;
}

.request-branch-btn:active { transform: translateY(0); }

.request-branch-btn__icon { flex-shrink: 0; }

/* Collapse to an icon-only pill on small screens to save navbar space */
@media (max-width: 991px) {
  .request-branch-btn { padding: 0 10px; }
  .request-branch-btn__label { display: none; }
}
</style>
